
<template>
  <div class="content-center">
    <div class="content-constraint">
      <NuxtChild />

      <section class="mb-12">
        <base-divider class="my-6" />
        <div style="text-align: center">
          <h2 class="font-title font-bold mb-6">
Frequently Asked Questions
</h2>
        </div>
        <p class="font-large">
          {{ faqIntroText }}
        </p>
        <slices-block v-if="slices" :slices="slices" />
      </section>
    </div>
  </div>
</template>

<script>
import prismicApi from "~/helpers/prismic-api"
import SlicesBlock from "@/components/slices/slices-block"

export default {
  name: "GiftCards",
  components: { SlicesBlock },
  head () {
    return {
      title: "eGift Cards"
    }
  },
  data: () => ({
    slices: null,
    faqIntroText: ""
  }),
  async asyncData () {
    const uid = "gift-card-faqs"
    const result = await prismicApi.getByUID("faq", uid)
    const faqIntroText = result.document.faq_intro_text
    const slices = result.document.body
    slices.forEach((s) => {
      s.items.forEach((p) => {
        p.showAnswer = false
      })
    })
    return {
      slices,
      faqIntroText
    }
  }
}
</script>
